.buttons-wrapper {
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 768px) {
    .button-group {
      order: 1;
    }
  }
}
